<template>
  <div ref="sceneMaterialImageAdding" class="sceneMaterialImageAdding alibabaPuHuiTiFontFamily">
    <img :src="imageInfo.thumbUrl" style="max-width:100%;max-height:200px;opacity:0.7;">
    <div style="position:absolute;bottom:-9px;left:50%;transform:translate(-50%,0);width:15px;height:15px;background:rgba(255, 255, 255, 0.5);border-radius:50%;"></div>
    <div style="position:absolute;bottom:-6px;left:50%;transform:translate(-50%,0);width:9px;height:9px;background:rgba(255, 255, 255, 1);border-radius:50%;"></div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";

export default {
  name: "SceneMaterialImageAdding",
  props:["imageInfo"],
  data() {
    return {
      marker: '',
    }
  },
  methods:{
    mouseMoveFun(e){
      this.marker.setLngLat([e.lngLat.lng, e.lngLat.lat])
    },

    //点击地图导入素材
    addMaterialImageOK(e){
      console.log(e)
      let currMaterialList = this.$store.state.currChooseSceneItemIndex !== ''
          ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialList
          : this.$store.state.tempMaterialInfo.materialList

      if(this.imageInfo.id !==undefined){
        //重新定位
        //修改列表数据
        for(let i=0;i<currMaterialList.length;i++){
          if(currMaterialList[i].id === this.imageInfo.id){
            //修改列表数据
            currMaterialList[i].geoJson.geo.geometry.coordinates = [e.lngLat.lng,e.lngLat.lat];
            break;
          }
        }

        //修改地图marker数据
        let currMaterialImageList;
        if(this.$store.state.currChooseSceneItemIndex !== ''){
          currMaterialImageList = this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.imageList
        }
        else{
          currMaterialImageList = this.$store.state.tempMaterialInfo.materialMarkerData.imageList
        }
        for(let i=0;i<currMaterialImageList.length;i++){
          if(currMaterialImageList[i].id === this.imageInfo.id){
            currMaterialImageList[i].geoJson.geo.geometry.coordinates = [e.lngLat.lng,e.lngLat.lat];
            break;
          }
        }

        this.$store.state.sceneMaterialImageAddingDataList = [];
        this.$store.state.sceneMaterialImageAdding = false;
      }
      else{
        //新增
        this.$utils.getNewId((newId)=>{
          console.log(newId)
          let currMaterialImageInfo = {
            "geoJson": {
              "geo": {
                "geometry": {
                  "coordinates": [
                    e.lngLat.lng,
                    e.lngLat.lat
                  ],
                  "type": "Point"
                },
                "id": newId,
                "type": "Feature",
                "properties": {
                  "visible": "visible",
                  "type": "image",
                  "name": this.imageInfo.name,
                  "id": newId,
                  "imageList": [],
                  "thumbUrl":this.imageInfo.thumbUrl,
                }
              },
              "points": []
            },
            "visible": true,
            "children": [],
            "iconShow": false,
            "name": this.imageInfo.name,
            "id": newId,
            "type": "image",
            "isEditName": false,
            //仅用于显示素材设置
            "showSet":{
              "timeRange":this.$store.state.scenePointEditing ? [0,this.$store.state.tempViewPointList.length] : [0,this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList.length],
              "allShowInScenePoint":false,
              "materialShowAnimation":"无",
              "materialHideAnimation":"无",
              "defaultStyle":false,
              "showName":false,
              "showPoint":false,
              "showMarkerImage":false,
              "showTop":false,
              "totalVisible":true,
            }
          };
          currMaterialList.push(currMaterialImageInfo)

          this.$emit("addMaterialImageFinish",currMaterialImageInfo);

          this.$store.state.sceneMaterialImageAddingDataList = [];
          this.$store.state.sceneMaterialImageAdding = false;
        })
      }


    },

    //点击屏幕
    clickScreen(e){
      console.log(e)
      if(e.target.className === "mapboxgl-canvas" || e.target.id === "labelCanvas"){
        console.log("点击地图")

      }
      else{
        console.log("点击非地图")
        this.$store.state.sceneMaterialImageAddingDataList = [];
        this.$store.state.sceneMaterialImageAdding = false;
      }
    }

  },
  mounted() {
    this.$parent.$parent.map.getCanvas().style.cursor = 'default';
    document.getElementById("labelCanvas").style.cursor = 'default';
    this.marker = new mapboxgl.Marker(this.$refs.sceneMaterialImageAdding,{
      anchor:"bottom",
      offset:[0,-10]
    }).setLngLat(this.$parent.$parent.map.getCenter())
        .addTo(this.$parent.$parent.map)
    //监听鼠标移动
    this.$parent.$parent.map.on('mousemove', this.mouseMoveFun)
    //监听鼠标点击
    this.$parent.$parent.map.once("click",this.addMaterialImageOK)
    //点击屏幕任意位置，退出定位状态
    document.addEventListener('click',this.clickScreen, {once:true});
  },
  destroyed() {
    this.$parent.$parent.map.getCanvas().style.cursor = '';
    document.getElementById("labelCanvas").style.cursor = '';
    this.$parent.$parent.map.off('mousemove', this.mouseMoveFun)
    this.$parent.$parent.map.off("click",this.addMaterialImageOK)
    document.removeEventListener('click',this.clickScreen);

    this.marker.remove()
  },
  render() {
    return null;
  },

}
</script>

<style scoped>

.sceneMaterialImageAdding{
  position:absolute;
  /*width:200px;*/
  /*height:200px;*/
  cursor:pointer;
}



</style>